import { useAuthUtils, useIdleTimeout, useUser } from '@hakimo-ui/hakimo/util';
import { DEFAULT_IDLE_TIMEOUT_MINUTES } from '../util';
import { ReactNode, useCallback } from 'react';
import { IdleTimeoutWarningModal } from './IdleTimeoutWarningModal';

interface Props {
  children: ReactNode;
}

export function IdleTimeoutProvider(props: Props) {
  const { children } = props;
  const user = useUser();
  const { logout } = useAuthUtils();

  const timeoutMinutes = user.idleTimeoutMinutes;
  const enabled = Boolean(timeoutMinutes && timeoutMinutes > 0);

  const handleTimeout = useCallback(() => {
    logout();
  }, [logout]);

  const { state, remainingSeconds, resetTimer } = useIdleTimeout({
    timeoutMinutes: timeoutMinutes || DEFAULT_IDLE_TIMEOUT_MINUTES,
    onTimeout: handleTimeout,
    enabled,
  });

  return (
    <>
      {children}
      {state === 'warning' && (
        <IdleTimeoutWarningModal
          remainingSeconds={remainingSeconds}
          onStayLoggedIn={resetTimer}
          onLogout={logout}
        />
      )}
    </>
  );
}
